import React, { useRef, useState } from "react";
import { Affix, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { Link, useLocation } from "react-router-dom";
import { getOGColor, isTablet, openWindow, parseURL } from "../util/Utils.js";
import { getColor, getFontFamily } from "../util/CC.js";
import CSS from "./utilities/CSS.js";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";


function SiteNav2(props) {

    const containerRef = useRef(null);
    const { mobile = false } = props;
    const history = useHistory();
    const {
        can_delete = false,
        container = true,
        visibility = "visible",
        expiry_action = false,
        start_date = null,
        end_date = null,
        date_created = 1684428651,
        date_changed = 1684429004,
        data = {},
    } = window.sitesettings.global_content.find(item => item.component === "nav_bar") || {};



   

    const template = window.sitesettings.template_info;

    const {
        text_colour = 0,
        text_preset = 0,
        background_colour = 0,
        selected_text_colour = 0,
        selected_background_colour = 0,
        letter_spacing = 0,
        selected_underline = false,
        selected_underline_colour = 0,
        selected_underline_thickness = 2,
        selected_animation = false,
        selected_animation_style = "left-animation",
        selected_animation_duration = 0.5,
        transform = "none",
        spacing = 20,
        font_size = 14,
        pinned = false
    } = data;

    const search_bar = window.sitesettings.global_content.find(item => item.component === "search_bar") || { data: { background_colour: background_colour, text_colour: text_colour } };


    const _spacing = (mobile) ? 20 : spacing;

    const loc = useLocation();

    const checkIsRel = (_path) => {
        if (_path.includes(".pdf")) {
            return false;
        }

        var pat = /^https?:\/\//i;
        if (pat.test(_path)) {
            if (_path.includes("bookmanager")) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    }

    const displayLink = (_item, click = false) => {

       

        if (_item.url === "events") {
            _item.url = "/events";
        }
        if (_item.url) {

            
            let isrel = checkIsRel(_item.url);
            let prefix = (isrel) ? window.sitesettings.basename.slice(0, -1) : "";
            if (isrel && _item.link_type !== "_blank") {
                
                
                if (click) {
                    history.push(_item.url);
                    return;
                }

                return <div style={{ "padding": "0px " + _spacing + "px" }} onClick={() => history.push(_item.url)} ><span className={`${selected_underline ? `animation ${selected_animation_style}` : ""}`}>{_item.label}</span></div>
            }
            else {
                
                if (click) {
                    openWindow(prefix + _item.url, _item.link_type);
                    return;
                }
                               
                return <div style={{ "padding": "0px " + _spacing + "px" }} onClick={() =>openWindow(prefix + _item.url, "_blank")}><span className={`${selected_underline ? `animation ${selected_animation_style}` : ""}`}>{_item.label}</span></div>
            }
        } else {

            if (click) {
                history.push((parseURL(_item)) ? parseURL(_item) : _item.path);
                return;
            }
            return (<div style={{ "padding": "0px " + _spacing + "px" }} onClick={() => history.push((parseURL(_item)) ? parseURL(_item) : _item.path)} key={_item.id}><span className={`${selected_underline ? `animation ${selected_animation_style}` : ""}`}>{_item.label}</span></div>)
        }
    }

    const getSelectPath = (_item) => {
        if (_item.url) {
            let isrel = checkIsRel(_item.url);
            if (isrel) {
                return _item.url;
            }
            else {
                return _item.url;
            }
        } else {
            return (parseURL(_item)) ? parseURL(_item) : _item.path;
        }
    }

    // if a top-level nav is not unlinked, create a new item
    const displayLinked = (_item) => {
        if (_item.type === "unlinked") {
            return (<></>)
        } else {
            return (<Menu.Item style={{ "padding": "0px" }} className="tab" key={_item.menu_id}>{displayLink(_item)}</Menu.Item>);
        }
    }

    const displayMenu = () => {

        return props.site_navigation.map((item, index) => {
            if (item.submenu.length > 0) {
                return (
                    <Menu.SubMenu style={{ "padding": "0px " + _spacing + "px" }} className="tab"
                        key={item.menu_id} data-test={item.path}
                        title={(<div aria-hidden className="notab" >{item.label}&nbsp;<DownOutlined style={{ "fontSize": "10px", "marginRight": "-5px" }} /></div>)}>
                        {displayLinked(item)}
                        {displaySubMenu(item.submenu)}
                    </Menu.SubMenu>
                )
            } else {
                return (
                    <Menu.Item style={{ "padding": "0px" }} className="tab" key={item.menu_id}>{displayLink(item)}</Menu.Item>
                );
            }
        });
    }

    const displaySubMenu = (_sub_menu) => {
        return _sub_menu.map((item, index) => {
            return (
                <Menu.Item onKeyDown={(e) => { if (e.key === "Enter") { displayLink(item, true) } }} style={{ "padding": "0px" }} className="tab" key={item.menu_id}>{displayLink(item)}</Menu.Item>
            );
        });
    }


    let _class = ``;

    _class += `.animation {
        position: relative;
    }`;

    _class += `.animation::after {
        content: '';
        position: absolute;
        width: 100%;
        transform: scaleX(0);
        height: ${selected_underline_thickness}px;
        bottom: -2px;
        left: 0;
        background-color: ${getColor(selected_underline_colour, template, "#000")};
        ${selected_animation ? `transition: transform ${selected_animation_duration}s ease-out;` : ""};    
    }`

    _class += `.animation:hover::after, 
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-selected .animation::after,
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-active .animation::after { 
        transform: scaleX(1);
    }`;

    _class += `.animation.left-animation::after {
        transform-origin: bottom right;
    }`;

    _class += `.animation.left-animation:hover::after,
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-selected .animation.left-animation::after,
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-active .animation.left-animation::after {
        transform-origin: bottom left;
    }`;

    _class += `.animation.right-animation::after {
        transform-origin: bottom left;
    }`;

    _class += `.animation.right-animation:hover::after,
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-selected .animation.right-animation::after,
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-active .animation.right-animation::after  {
        transform-origin: bottom right;
    }`;

    _class += `.animation.center-animation::after {
        transform-origin: bottom center;
    }`;

    _class += `.animation.center-animation:hover::after,
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-selected .animation.center-animation::after,
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-active .animation.center-animation::after {
        transform-origin: bottom center;
    }`;

    _class += `.ant-menu-horizontal > .ant-menu-submenu > .ant-menu-submenu-title{
        color: ${getColor(text_colour, template, getOGColor("main_text_colour", "#000"))};
    }`

    _class += `.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title{
        color: ${getColor(text_colour, template, getOGColor("main_text_colour", "#000"))};
    }`

    _class += `.ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title{
        color: ${getColor(selected_text_colour, template, getOGColor("open_menu_text_colour", "#fff"))};
        
    }`

    _class += `.ant-menu-inline > .ant-menu-submenu-selected > .ant-menu-submenu-title{
        color: ${getColor(selected_text_colour, template, getOGColor("open_menu_text_colour", "#fff"))};
        
    }`

    _class += `
    .ant-menu-dark .ant-menu-item > span > a{
        color: ${getColor(text_colour, template, getOGColor("main_text_colour", "#000"))};
        transition: color .3s, border-color .3s, background .3s
    }`;

    _class += `
    .ant-menu-dark .ant-menu-item > span > a:hover{
        color: ${getColor(selected_text_colour, template, getOGColor("open_menu_text_colour", "#fff"))};
        transition: color .3s, border-color .3s, background .3s
    }`;

    _class += `
    .ant-menu-dark .ant-menu-item-selected > span > a{
        color: ${getColor(selected_text_colour, template, getOGColor("open_menu_text_colour", "#fff"))};
        transition: color .3s, border-color .3s, background .3s
    }`;

    _class += `
    .bm_nav .ant-menu-dark.ant-menu-horizontal > .ant-menu-item, .ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu > .ant-menu-submenu-title{
        padding: 0px ${_spacing}px;
    }`;

    _class += `
    .ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu{
        padding : 0px !important;
    }`;


    _class += `
    .bm_nav, .bm_nav .ant-menu.ant-menu-dark, .bm_nav .ant-menu-item, .bm_nav .ant-menu-sub{
        background: transparent;
        color: ${getColor(text_colour, template, getOGColor("main_text_colour", "#000"))} !important;
        font-family: '${getFontFamily(text_preset, template)}';
        text-transform : ${transform};
        transition: color .3s, border-color .3s, background .3s;
        font-size : ${font_size}px;
        letter-spacing : ${letter_spacing}px;
    }`;

    _class += `
    .bm_nav, .bm_nav .ant-menu.ant-menu-dark, bm_nav, .bm_nav .ant-menu.ant-menu{
        background: ${getColor(background_colour, template, getOGColor("main_colour", "#fff"))};
    }`;

    //hover, selected... 

    _class += `
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-selected, .bm_nav .ant-menu.ant-menu-dark .ant-menu-submenu-active, .bm_nav .ant-menu.ant-menu-dark .ant-menu-submenu-selected, .bm_nav .ant-menu.ant-menu-dark .ant-menu-submenu-active .ant-menu-submenu-title, .bm_nav .ant-menu.ant-menu-dark .ant-menu-submenu-title:hover, .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-active, .bm_nav .ant-menu-submenu-active, .bm_nav .ant-menu-submenu-selected {
        background: ${getColor(selected_background_colour, template, getOGColor("open_menu_background_colour", "#000"))} !important;
        color: ${getColor(selected_text_colour, template, getOGColor("open_menu_text_colour", "#fff"))} !important;
        transition: color 0s, border-color .0s, background .0s
    }`;

    // fix
    _class += `
        .bm_nav .ant-menu-dark.ant-menu-horizontal .ant-menu-submenu:hover, .ant-menu-dark.ant-menu-horizontal .ant-menu-submenu:hover > a, .ant-menu-dark.ant-menu-horizontal .ant-menu-submenu:focus-within, .ant-menu-dark.ant-menu-horizontal .ant-menu-submenu:focus-within > a{
            background: ${getColor(selected_background_colour, template, getOGColor("open_menu_background_colour", "#000"))} !important;
        }
    `;

    _class += `
        .ant-menu-item:hover, .ant-menu-item-active, .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open, .ant-menu-submenu-active, .ant-menu-submenu-title:hover, .ant-menu-submenu-title:focus-within{
            background: ${getColor(selected_background_colour, template, getOGColor("open_menu_background_colour", "#000"))} !important;
        }
    `
    _class += `
        .ant-menu-horizontal > .ant-menu-submenu:focus-within > .ant-menu-submenu-title{
            color: ${getColor(selected_text_colour, template, getOGColor("open_menu_text_colour", "#fff"))} !important;
        }
    `

    _class += `
    .bm_nav, .bm_nav .ant-menu.ant-menu-dark, bm_nav, .bm_nav .ant-menu.ant-menu{
        background: ${getColor(background_colour, template, getOGColor("main_colour", "#fff"))};
    }`;

    _class += `
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-submenu-title,  .bm_nav .ant-menu.ant-menu-dark .ant-menu-submenu-title:hover{
        background:none !important;
    }
    `

    // submenu 
    _class += `
    .bm_nav .ant-menu-vertical {
        background: ${getColor(background_colour, template, getOGColor("main_colour", "#fff"))} !important;
        border-radius: 0px !important;
        transition: color .3s, border-color .3s, background .3s
    }`;

    _class += `
    .bm_nav.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item {
        margin: 0px;
        transition: color .3s, border-color .3s, background .3s
    }`;

    _class += `
    .bm_nav.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected, .ant-menu-dark .ant-menu-submenu-title:hover,  .bm_nav.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item:hover, .bm_nav .ant-menu-item:focus-within{
        background: ${getColor(selected_background_colour, template, getOGColor("open_menu_background_colour", "#000"))} !important;
        color: ${getColor(selected_text_colour, template, getOGColor("open_menu_text_colour", "#fff"))} !important;
        transition: color .3s, border-color .3s, background .3s
    }`;

    _class += `
    .bm_nav.ant-menu-dark.ant-menu-inline .ant-menu-submenu:hover, .bm_nav.ant-menu-dark.ant-menu-inline .ant-menu-submenu:hover > a, .bm_nav.ant-menu-dark.ant-menu-inline .ant-menu-submenu:focus-within, .bm_nav.ant-menu-dark.ant-menu-inline .ant-menu-submenu:focus-within > a{
        background: ${getColor(selected_background_colour, template, getOGColor("open_menu_background_colour", "#000"))} !important;
        color: ${getColor(selected_text_colour, template, getOGColor("open_menu_text_colour", "#fff"))} !important;
        transition: color .3s, border-color .3s, background .3s
    }`;

    _class += `
    .bm_nav.ant-menu-inline > .ant-menu-submenu:hover > .ant-menu-submenu-title, .bm_nav.ant-menu-inline > .ant-menu-submenu:focus-within > .ant-menu-submenu-title{
        color: ${getColor(selected_text_colour, template, getOGColor("open_menu_text_colour", "#fff"))} !important;
    }`;

    _class += `
    .bm_nav .ant-menu-item:focus-within > span > a {
        color: ${getColor(selected_text_colour, template, getOGColor("open_menu_text_colour", "#fff"))} !important;
    }`;

    _class += `
    .ant-drawer-header{
        background: ${getColor(search_bar.data.background_colour, template, getOGColor("search_bar_colour", "#fff"))} !important;
        border-bottom: 1px solid ${getColor(search_bar.data.background_colour, template, getOGColor("search_bar_colour", "#fff"))} !important;
    }
    `

    _class += `
    .ant-drawer-header .ant-drawer-title{
        color : ${getColor(search_bar.data.text_colour, template, getOGColor("search_bar_text_colour", "#fff"))} !important;
    }
    `


    const findMenuId = (_path) => {
        let ret = "";
        window.sitesettings.site_navigation.forEach(element => {
            if (element.path === _path) {
                ret = element.menu_id
            }
            element.submenu.forEach(child => {
                if (child.path === _path) {
                    ret = child.menu_id
                }
            });
        });
        return ret;
    }

    const draw = () => {

        return (
            <div className={(!mobile) ? "menubg hide-block" : ""} style={{ "maxWidth": "100%", "height": "46px" }}>
                <Menu
                    className="bm_nav"
                    rootClassName="bm_nav"
                    forceSubMenuRender={(isTablet()) ? false :true}
                    overflowedIndicator={<>More Menus</>}
                    selectedKeys={[findMenuId(loc.pathname)]}
                    triggerSubMenuAction={(isTablet()) ? "click" : "hover"}
                    style={{ "maxWidth": (container) ? "1248px" : "100%", "margin": "0 auto", "minHeight": (mobile) ? "calc(100vh - 55px)" : "inherit" }}
                    mode={(mobile) ? "inline" : "horizontal"}
                    theme="dark"
                >

                    {displayMenu()}
                </Menu>
            </div>
        )
    }


    const search = document.getElementById("search_bg");
    let search_bar_height = (search) ? search.offsetHeight : 0;

    const sb = window.sitesettings.global_content.find(item => item.component === "search_bar");
    if (sb) {
        if (sb?.data.pin_navigation === false) {
            search_bar_height = 0;
        }
    }


    return (
        <>
            <CSS prepend html={_class} />

            <div>
                {(pinned) ? <Affix offsetTop={search_bar_height}><nav className="bm_nav bm-render"><div style={{ "marginTop": "-2px" }}>{draw()}</div></nav></Affix> : <><nav className="bm_nav bm-render">{draw()}</nav></>}
            </div>
        </>
    );
}

export default SiteNav2;

